// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";

// import Features from "./Features";
// import GetApp from "./GetApp";
// import HeroSection from "./HeroSection";
// import Testimonials from "./Testimonials";
// import CultureSection from "./featureintro";
// import MobileFeatures from "./MobileFeatures";

// const smoothSpring = {
//   stiffness: 40,
//   damping: 30,
//   mass: 1.2,
// };

// const Home = () => {
//   const toolsRef = useRef(null);

// {/* Note Section After Features */}
// <div className="px-8 md:px-20 py-6 max-w-6xl mx-auto text-gray-800 text-lg md:text-xl font-medium flex items-start gap-2">
//     <span className="text-red-600 text-xl md:text-2xl">*</span>
//     <p className="leading-relaxed">
//         Pricing is flexible and tailored to your specific requirements. Costs may vary depending on the level of customization and features you choose for your software.
//     </p>
// </div>

//   /* Heading scroll motion */
//   const headingY = useSpring(
//     useTransform(scrollYProgress, [0.25, 0.55], [60, -60]),
//     smoothSpring
//   );

// const toolsRef = useRef(null);
// const portalRef = useRef(null);

// const { scrollYProgress: toolsProgress } = useScroll({
//   target: toolsRef,
//   offset: ["start end", "end start"],
// });

// const { scrollYProgress: portalProgress } = useScroll({
//   target: portalRef,
//   offset: ["start end", "end start"],
// });

// const toolsHeadingY = useSpring(
//   useTransform(toolsProgress, [0.25, 0.55], [60, -60]),
//   smoothSpring
// );

// const portalHeadingY = useSpring(
//   useTransform(portalProgress, [0.25, 0.55], [60, -60]),
//   smoothSpring
// );


//   return (
//     <main className="bg-white text-[#141414] overflow-hidden">
//       {/* ================= HERO ================= */}
//       <HeroSection />

//       {/* ================= TOOLS HEADING (CODEWAY STYLE) ================= */}
//       <section ref={toolsRef} className="relative py-32 bg-white">
//         {/* MASK */}
//         <div className="relative overflow-hidden h-[120px] md:h-[160px]">
//           {/* BACK / GHOST TEXT */}
//           <div className="absolute inset-0 flex justify-center items-center">
//             <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-gray-300">
//               Tools Built for Legal Excellence
//             </h2>
//           </div>

//           {/* FRONT / MOVING TEXT */}
//           <motion.div
//             style={{ y: toolsHeadingY }}
//             className="absolute inset-0 flex justify-center items-center"
//           >
//             <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-[#141414]">
//               Tools Built for Legal Excellence
//             </h2>
//           </motion.div>
//         </div>

//         {/* SUBTEXT (STATIC) */}
//         <p className="mt-10 max-w-3xl mx-auto text-lg md:text-xl text-gray-600 leading-relaxed text-center px-6">
//           Modernize your practice with features designed by and for legal professionals.
//           Secure, efficient, and client-ready.
//         </p>
//       </section>

//       {/* ================= FEATURES ================= */}
//       <section className="mt-32">
//         <Features />
//       </section>

//       <section ref={portalRef} className="relative py-32 bg-white">
//         {/* MASK */}
//         <div className="relative overflow-hidden h-[120px] md:h-[160px]">
          

//           {/* FRONT / MOVING TEXT */}
//           <motion.div
//             style={{ y: portalHeadingY }}
//             className="absolute inset-0 flex justify-center items-center"
//           >
//             <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-[#141414]">
//               We are not limited to just a portal!
//             </h2>
//           </motion.div>
//         </div>
//       </section>
//       <section className="mt-32">
//         <MobileFeatures/>
//       </section>

//       {/* ================= TESTIMONIALS ================= */}
//       <section className="mt-32">
//         <Testimonials />
//       </section>

//       {/* ================= GET APP ================= */}
//       <section className="mt-32 mb-32">
//         <GetApp />
//       </section>
//     </main>
//   );
// };

// export default Home;










// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";

// import Features from "./Features";
// import GetApp from "./GetApp";
// import HeroSection from "./HeroSection";
// import Testimonials from "./Testimonials";
// import CultureSection from "./featureintro";
// import MobileFeatures from "./MobileFeatures";

// const smoothSpring = {
//   stiffness: 40,
//   damping: 30,
//   mass: 1.2,
// };

// const Home = () => {
//   /* ---------------- REFS ---------------- */
//   const toolsRef = useRef(null);
//   const portalRef = useRef(null);

//   /* ---------------- SCROLL PROGRESS ---------------- */
//   const { scrollYProgress: toolsProgress } = useScroll({
//     target: toolsRef,
//     offset: ["start end", "end start"],
//   });

//   const { scrollYProgress: portalProgress } = useScroll({
//     target: portalRef,
//     offset: ["start end", "end start"],
//   });

//   /* ---------------- TRANSFORMS ---------------- */
//   const toolsHeadingY = useSpring(
//     useTransform(toolsProgress, [0.25, 0.55], [60, -60]),
//     smoothSpring
//   );

//   const portalHeadingY = useSpring(
//     useTransform(portalProgress, [0.25, 0.55], [60, -60]),
//     smoothSpring
//   );

//   return (
//     <main className="bg-white text-[#141414] overflow-hidden">
//       {/* ================= HERO ================= */}
//       <HeroSection />

//       {/* ================= TOOLS HEADING ================= */}
//       <section ref={toolsRef} className="relative py-32 bg-white">
//         <div className="relative overflow-hidden h-[120px] md:h-[160px]">
//           {/* BACK TEXT */}
//           <div className="absolute inset-0 flex justify-center items-center">
//             <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-gray-300">
//               Tools Built for Legal Excellence
//             </h2>
//           </div>

//           {/* FRONT TEXT */}
//           <motion.div
//             style={{ y: toolsHeadingY }}
//             className="absolute inset-0 flex justify-center items-center"
//           >
//             <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-[#141414]">
//               Tools Built for Legal Excellence
//             </h2>
//           </motion.div>
//         </div>

//         <p className="mt-10 max-w-3xl mx-auto text-lg md:text-xl text-gray-600 leading-relaxed text-center px-6">
//           Modernize your practice with features designed by and for legal professionals.
//           Secure, efficient, and client-ready.
//         </p>
//       </section>

//       {/* ================= FEATURES ================= */}
//       <section className="mt-32">
//         <Features />
//       </section>

//       {/* ================= PORTAL HEADING ================= */}
//       <section ref={portalRef} className="relative py-32 bg-white">
//         <div className="relative overflow-hidden h-[120px] md:h-[160px]">
//           <motion.div
//             style={{ y: portalHeadingY }}
//             className="absolute inset-0 flex justify-center items-center"
//           >
//             <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-[#141414]">
//               We are not limited to just a portal!
//             </h2>
//           </motion.div>
//         </div>
//       </section>

//       {/* ================= MOBILE FEATURES ================= */}
//       <section className="mt-32">
//         <MobileFeatures />
//       </section>

//       {/* ================= TESTIMONIALS ================= */}
//       <section className="mt-32">
//         <Testimonials />
//       </section>

//       {/* ================= GET APP ================= */}
//       <section className="mt-32 mb-32">
//         <GetApp />
//       </section>
//     </main>
//   );
// };

// export default Home;








// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";

// import Features from "./Features";
// import GetApp from "./GetApp";
// import HeroSection from "./HeroSection";
// import Testimonials from "./Testimonials";
// import CultureSection from "./featureintro";
// import MobileFeatures from "./MobileFeatures";

// const smoothSpring = {
//   stiffness: 40,
//   damping: 30,
//   mass: 1.2,
// };

// const Home = () => {
//   /* ---------------- REFS ---------------- */
//   const toolsRef = useRef(null);
//   const portalRef = useRef(null);

//   /* ---------------- SCROLL PROGRESS ---------------- */
//   const { scrollYProgress: toolsProgress } = useScroll({
//     target: toolsRef,
//     offset: ["start end", "end start"],
//   });

//   const { scrollYProgress: portalProgress } = useScroll({
//     target: portalRef,
//     offset: ["start end", "end start"],
//   });

//   /* ---------------- TRANSFORMS ---------------- */
//   const toolsHeadingY = useSpring(
//     useTransform(toolsProgress, [0.25, 0.55], [60, -60]),
//     smoothSpring
//   );

//   const portalHeadingY = useSpring(
//     useTransform(portalProgress, [0.25, 0.55], [60, -60]),
//     smoothSpring
//   );

//   return (
//     <main className="bg-white text-[#141414] overflow-hidden">
//       {/* ================= HERO ================= */}
//       <HeroSection />

//       {/* ================= TOOLS BUILT FOR LEGAL EXCELLENCE ================= */}
//       <section
//         ref={toolsRef}
//         className="relative py-40 bg-gradient-to-b from-[#EEF1F7] to-[#F4F6FB]"
//       >
//         {/* Ambient shapes */}
//         <div className="absolute -top-24 left-1/3 w-[420px] h-[420px] bg-[#6B7FD7]/15 rounded-full blur-[120px]" />
//         <div className="absolute bottom-0 right-1/4 w-[360px] h-[360px] bg-[#94A3FF]/15 rounded-full blur-[120px]" />

//         <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
//           <motion.h2
//             style={{ y: toolsHeadingY }}
//             className="text-4xl md:text-6xl font-semibold tracking-tight text-[#1F2A44]"
//           >
//             Tools Built for Legal Excellence
//           </motion.h2>

//           <motion.p
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.25, duration: 0.8 }}
//             className="mt-10 max-w-3xl mx-auto text-lg md:text-xl text-[#3B4A6B] leading-relaxed"
//           >
//             Jurident empowers legal professionals with thoughtfully engineered
//             tools that enhance precision, efficiency, and confidence in every
//             legal workflow.
//           </motion.p>

//           {/* Feature cards */}
//           <motion.div
//             initial={{ opacity: 0 }}
//             whileInView={{ opacity: 1 }}
//             transition={{ delay: 0.45 }}
//             className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-10"
//           >
//             {[
//               {
//                 title: "Built for Legal Workflows",
//                 desc: "Purpose-designed features aligned with real courtroom and office practices.",
//               },
//               {
//                 title: "Accuracy & Compliance",
//                 desc: "Structured data handling and controlled outputs you can rely on.",
//               },
//               {
//                 title: "Scales With You",
//                 desc: "Equally powerful for individual lawyers and growing legal teams.",
//               },
//             ].map((item, i) => (
//               <motion.div
//                 key={i}
//                 whileHover={{ y: -6 }}
//                 transition={{ type: "spring", stiffness: 200 }}
//                 className="rounded-3xl bg-white/80 backdrop-blur-xl border border-[#E1E6F0] p-8 shadow-[0_20px_60px_rgba(20,30,60,0.12)]"
//               >
//                 <h3 className="text-xl font-semibold text-[#1F2A44]">
//                   {item.title}
//                 </h3>
//                 <p className="mt-3 text-[#4B5A7A] leading-relaxed">
//                   {item.desc}
//                 </p>
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </section>

//       {/* ================= FEATURES ================= */}
//       <section className="mt-32">
//         <Features />
//       </section>

//       {/* ================= NOT JUST A PORTAL ================= */}
//       <section
//         ref={portalRef}
//         className="relative py-40 bg-gradient-to-b from-[#F4F6FB] to-[#EEF1F7]"
//       >
//         {/* Depth gradients */}
//         <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(107,127,215,0.12),transparent_40%)]" />
//         <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_60%,rgba(148,163,255,0.12),transparent_40%)]" />

//         <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
//           <motion.h2
//             style={{ y: portalHeadingY }}
//             className="text-4xl md:text-6xl font-semibold tracking-tight text-[#1F2A44]"
//           >
//             We are not limited to just a portal!
//           </motion.h2>

//           <motion.p
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.25, duration: 0.8 }}
//             className="mt-10 max-w-3xl mx-auto text-lg md:text-xl text-[#3B4A6B] leading-relaxed"
//           >
//             Jurident is a complete legal ecosystem — seamlessly connecting web,
//             mobile, scheduling, collaboration, and automation into one unified
//             experience.
//           </motion.p>

//           {/* Ecosystem cards */}
//           <motion.div
//             initial={{ opacity: 0 }}
//             whileInView={{ opacity: 1 }}
//             transition={{ delay: 0.45 }}
//             className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-10"
//           >
//             {[
//               {
//                 title: "Powerful Web Platform",
//                 desc: "A responsive and secure portal for complete case and client management.",
//               },
//               {
//                 title: "Mobile-First Access",
//                 desc: "Stay updated with hearings, tasks, and notifications on the go.",
//               },
//               {
//                 title: "Connected Legal Ecosystem",
//                 desc: "Calendar sync, team collaboration, and intelligent integrations.",
//               },
//             ].map((item, i) => (
//               <motion.div
//                 key={i}
//                 whileHover={{ scale: 1.03 }}
//                 transition={{ type: "spring", stiffness: 180 }}
//                 className="rounded-3xl bg-white/70 backdrop-blur-xl border border-[#E1E6F0] p-8 shadow-[0_20px_60px_rgba(20,30,60,0.12)]"
//               >
//                 <h3 className="text-xl font-semibold text-[#1F2A44]">
//                   {item.title}
//                 </h3>
//                 <p className="mt-3 text-[#4B5A7A] leading-relaxed">
//                   {item.desc}
//                 </p>
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </section>

//       {/* ================= MOBILE FEATURES ================= */}
//       <section className="mt-32">
//         <MobileFeatures />
//       </section>

//       {/* ================= TESTIMONIALS ================= */}
//       <section className="mt-32">
//         <Testimonials />
//       </section>

//       {/* ================= GET APP ================= */}
//       <section className="mt-32 mb-32">
//         <GetApp />
//       </section>
//     </main>
//   );
// };

// export default Home;

















// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";

// import Features from "./Features";
// import GetApp from "./GetApp";
// import HeroSection from "./HeroSection";
// import Testimonials from "./Testimonials";
// import MobileFeatures from "./MobileFeatures";

// const smoothSpring = {
//   stiffness: 40,
//   damping: 30,
//   mass: 1.2,
// };

// const Home = () => {
//   /* ---------------- REFS ---------------- */
//   const toolsRef = useRef(null);
//   const portalRef = useRef(null);

//   /* ---------------- SCROLL PROGRESS ---------------- */
//   const { scrollYProgress: toolsProgress } = useScroll({
//     target: toolsRef,
//     offset: ["start end", "end start"],
//   });

//   const { scrollYProgress: portalProgress } = useScroll({
//     target: portalRef,
//     offset: ["start end", "end start"],
//   });

//   /* ---------------- TRANSFORMS ---------------- */
//   const toolsHeadingY = useSpring(
//     useTransform(toolsProgress, [0.25, 0.55], [60, -60]),
//     smoothSpring
//   );

//   const portalHeadingY = useSpring(
//     useTransform(portalProgress, [0.25, 0.55], [60, -60]),
//     smoothSpring
//   );

//   return (
//     <main className="bg-white text-[#141414] overflow-hidden">
//       {/* ================= HERO ================= */}
//       <HeroSection />

//       {/* ================= TOOLS BUILT FOR LEGAL EXCELLENCE ================= */}
//       <section
//         ref={toolsRef}
//         className="relative py-40 bg-gradient-to-b from-[#EEF1F7] to-[#F4F6FB]"
//       >
//         {/* Ambient shapes */}
//         <div className="absolute -top-24 left-1/3 w-[420px] h-[420px] bg-[#6B7FD7]/15 rounded-full blur-[120px]" />
//         <div className="absolute bottom-0 right-1/4 w-[360px] h-[360px] bg-[#94A3FF]/15 rounded-full blur-[120px]" />

//         <div className="relative overflow-hidden h-[120px] md:h-[160px]">
//           {/* BACK TEXT */}
//           <div className="absolute inset-0 flex justify-center items-center">
//             <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-[#C5CCD8]">
//               Tools Built for Legal Excellence
//             </h2>
//           </div>

//           {/* FRONT TEXT (ORIGINAL SCROLL ANIMATION KEPT) */}
//           <motion.div
//             style={{ y: toolsHeadingY }}
//             className="absolute inset-0 flex justify-center items-center"
//           >
//             <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-[#1F2A44]">
//               Tools Built for Legal Excellence
//             </h2>
//           </motion.div>
//         </div>

//         <p className="mt-12 max-w-3xl mx-auto text-lg md:text-xl text-[#3B4A6B] leading-relaxed text-center px-6">
//           Modernize your practice with tools purpose-built for legal workflows —
//           enhancing accuracy, efficiency, and confidence at every stage.
//         </p>

//         {/* Supporting content */}
//         <div className="mt-20 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 px-6">
//           {[
//             {
//               title: "Designed for Lawyers",
//               desc: "Every feature mirrors real courtroom and office workflows.",
//             },
//             {
//               title: "Precision & Control",
//               desc: "Structured systems that prioritize compliance and clarity.",
//             },
//             {
//               title: "Scalable by Nature",
//               desc: "Equally powerful for solo practitioners and legal teams.",
//             },
//           ].map((item, i) => (
//             <motion.div
//               key={i}
//               whileHover={{ y: -6 }}
//               transition={{ type: "spring", stiffness: 200 }}
//               className="rounded-3xl bg-white/80 backdrop-blur-xl border border-[#E1E6F0] p-8 shadow-[0_20px_60px_rgba(20,30,60,0.12)]"
//             >
//               <h3 className="text-xl font-semibold text-[#1F2A44]">
//                 {item.title}
//               </h3>
//               <p className="mt-3 text-[#4B5A7A] leading-relaxed">
//                 {item.desc}
//               </p>
//             </motion.div>
//           ))}
//         </div>
//       </section>

//       {/* ================= FEATURES ================= */}
//       <section className="mt-32">
//         <Features />
//       </section>

//       {/* ================= NOT JUST A PORTAL ================= */}
//       <section
//         ref={portalRef}
//         className="relative py-40 bg-gradient-to-b from-[#F4F6FB] to-[#EEF1F7]"
//       >
//         {/* Soft depth gradients */}
//         <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(107,127,215,0.12),transparent_40%)]" />
//         <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_60%,rgba(148,163,255,0.12),transparent_40%)]" />

//         <div className="relative overflow-hidden h-[120px] md:h-[160px]">
//           <motion.div
//             style={{ y: portalHeadingY }}
//             className="absolute inset-0 flex justify-center items-center"
//           >
//             <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-[#1F2A44]">
//               We are not limited to just a portal!
//             </h2>
//           </motion.div>
//         </div>

//         <p className="mt-12 max-w-3xl mx-auto text-lg md:text-xl text-[#3B4A6B] leading-relaxed text-center px-6">
//           Jurident is a connected legal ecosystem — combining web, mobile,
//           scheduling, collaboration, and automation into one seamless experience.
//         </p>

//         <div className="mt-20 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 px-6">
//           {[
//             {
//               title: "Powerful Web Platform",
//               desc: "A secure and responsive portal for complete case control.",
//             },
//             {
//               title: "Mobile-First Experience",
//               desc: "Access hearings, tasks, and updates anytime, anywhere.",
//             },
//             {
//               title: "Unified Legal Ecosystem",
//               desc: "Calendar sync, collaboration, and intelligent integrations.",
//             },
//           ].map((item, i) => (
//             <motion.div
//               key={i}
//               whileHover={{ scale: 1.03 }}
//               transition={{ type: "spring", stiffness: 180 }}
//               className="rounded-3xl bg-white/70 backdrop-blur-xl border border-[#E1E6F0] p-8 shadow-[0_20px_60px_rgba(20,30,60,0.12)]"
//             >
//               <h3 className="text-xl font-semibold text-[#1F2A44]">
//                 {item.title}
//               </h3>
//               <p className="mt-3 text-[#4B5A7A] leading-relaxed">
//                 {item.desc}
//               </p>
//             </motion.div>
//           ))}
//         </div>
//       </section>

//       {/* ================= MOBILE FEATURES ================= */}
//       <section className="mt-32">
//         <MobileFeatures />
//       </section>

//       {/* ================= TESTIMONIALS ================= */}
//       <section className="mt-32">
//         <Testimonials />
//       </section>

//       {/* ================= GET APP ================= */}
//       <section className="mt-32 mb-32">
//         <GetApp />
//       </section>
//     </main>
//   );
// };

// export default Home;











// //final version
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";

// import Features from "./Features";
// import GetApp from "./GetApp";
// import HeroSection from "./HeroSection";
// import Testimonials from "./Testimonials";
// import MobileFeatures from "./MobileFeatures";

// const smoothSpring = {
//   stiffness: 40,
//   damping: 30,
//   mass: 1.2,
// };

// const Home = () => {
//   /* ---------------- REFS ---------------- */
//   const toolsRef = useRef(null);
//   const portalRef = useRef(null);

//   /* ---------------- SCROLL PROGRESS ---------------- */
//   const { scrollYProgress: toolsProgress } = useScroll({
//     target: toolsRef,
//     offset: ["start end", "end start"],
//   });

//   const { scrollYProgress: portalProgress } = useScroll({
//     target: portalRef,
//     offset: ["start end", "end start"],
//   });

//   /* ---------------- TRANSFORMS ---------------- */
//   const toolsHeadingY = useSpring(
//     useTransform(toolsProgress, [0.25, 0.55], [60, -60]),
//     smoothSpring
//   );

//   const portalHeadingY = useSpring(
//     useTransform(portalProgress, [0.25, 0.55], [60, -60]),
//     smoothSpring
//   );

//   return (
//     <main className="bg-white text-[#141414] overflow-hidden">
//       {/* ================= HERO ================= */}
//       <HeroSection />

//       {/* ================= TOOLS BUILT FOR LEGAL EXCELLENCE ================= */}
//       <section
//         ref={toolsRef}
//         className="
//           relative py-44 overflow-hidden
//           bg-[radial-gradient(ellipse_at_top,#E9EEFF_0%,#F4F7FF_40%,#F8FAFF_100%)]
//         "
//       >
//         {/* Ambient depth */}
//         <div className="absolute -top-32 left-1/4 w-[520px] h-[520px] bg-indigo-400/10 rounded-full blur-[160px]" />
//         <div className="absolute top-40 right-1/4 w-[420px] h-[420px] bg-blue-300/10 rounded-full blur-[140px]" />

//         {/* Heading */}
//         <div className="relative overflow-hidden h-[140px] md:h-[180px]">
//           {/* Ghost text */}
//           <div className="absolute inset-0 flex justify-center items-center">
//             <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-[#CBD3E3]">
//               Tools Built for Legal Excellence
//             </h2>
//           </div>

//           {/* Animated text (ORIGINAL SCROLL STYLE) */}
//           <motion.div
//             style={{ y: toolsHeadingY }}
//             className="absolute inset-0 flex justify-center items-center"
//           >
//             <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-[#1E2A44]">
//               Tools Built for Legal Excellence
//             </h2>
//           </motion.div>
//         </div>

//         {/* Description */}
//         <p className="mt-12 max-w-3xl mx-auto text-lg md:text-xl text-[#4A5B7C] leading-relaxed text-center px-6">
//           Modernize your practice with tools purpose-built for legal workflows —
//           enhancing accuracy, efficiency, and confidence at every stage.
//         </p>

//         {/* Feature Cards */}
//         <div className="mt-24 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 px-6">
//           {[
//             {
//               title: "Designed for Lawyers",
//               desc: "Every feature mirrors real courtroom and office workflows.",
//             },
//             {
//               title: "Precision & Control",
//               desc: "Structured systems that prioritize compliance and clarity.",
//             },
//             {
//               title: "Scalable by Nature",
//               desc: "Equally powerful for solo practitioners and legal teams.",
//             },
//           ].map((item, i) => (
//             <motion.div
//               key={i}
//               whileHover={{ y: -8 }}
//               transition={{ type: "spring", stiffness: 160 }}
//               className="
//                 rounded-[28px]
//                 bg-white/85
//                 backdrop-blur-xl
//                 border border-[#E2E8F4]
//                 p-9
//                 shadow-[0_30px_90px_rgba(30,40,90,0.14)]
//               "
//             >
//               <h3 className="text-xl font-semibold text-[#1E2A44]">
//                 {item.title}
//               </h3>
//               <p className="mt-3 text-[#55658A] leading-relaxed">
//                 {item.desc}
//               </p>
//             </motion.div>
//           ))}
//         </div>
//       </section>

//       {/* ================= FEATURES ================= */}
//       <section className="mt-32">
//         <Features />
//       </section>

//       {/* ================= NOT JUST A PORTAL ================= */}
      

//       {/* ================= MOBILE FEATURES ================= */}
//       <section className="mt-32">
//         <MobileFeatures />
//       </section>

//       {/* ================= TESTIMONIALS ================= */}
//       <section className="mt-32">
//         <Testimonials />
//       </section>

//       {/* ================= GET APP ================= */}
//       <section className="mt-32 mb-32">
//         <GetApp />
//       </section>
//     </main>
//   );
// };

// export default Home;


















// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";

// import Features from "./Features";
// import GetApp from "./GetApp";
// import HeroSection from "./HeroSection";
// import Testimonials from "./Testimonials";
// import MobileFeatures from "./MobileFeatures";

// const smoothSpring = {
//   stiffness: 40,
//   damping: 30,
//   mass: 1.2,
// };

// const Home = () => {
//   const toolsRef = useRef(null);

//   const { scrollYProgress: toolsProgress } = useScroll({
//     target: toolsRef,
//     offset: ["start end", "end start"],
//   });

//   const toolsHeadingY = useSpring(
//     useTransform(toolsProgress, [0.25, 0.55], [60, -60]),
//     smoothSpring
//   );

//   return (
//     <main className="bg-white text-[#141414] overflow-hidden">
//       {/* ================= HERO ================= */}
//       <HeroSection />

//       {/* ================= TOOLS BUILT FOR LEGAL EXCELLENCE ================= */}
//       <section
//         ref={toolsRef}
//         className="
//           relative py-44 overflow-hidden
//           bg-[radial-gradient(ellipse_at_top,#E9EEFF_0%,#F4F7FF_40%,#F8FAFF_100%)]
//         "
//       >
//         <div className="absolute -top-32 left-1/4 w-[520px] h-[520px] bg-indigo-400/10 rounded-full blur-[160px]" />
//         <div className="absolute top-40 right-1/4 w-[420px] h-[420px] bg-blue-300/10 rounded-full blur-[140px]" />

//         <div className="relative overflow-hidden h-[140px] md:h-[180px]">
//           <div className="absolute inset-0 flex justify-center items-center">
//             <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-[#CBD3E3]">
//               Tools Built for Legal Excellence
//             </h2>
//           </div>

//           <motion.div
//             style={{ y: toolsHeadingY }}
//             className="absolute inset-0 flex justify-center items-center"
//           >
//             <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-[#1E2A44]">
//               Tools Built for Legal Excellence
//             </h2>
//           </motion.div>
//         </div>

//         <p className="mt-12 max-w-3xl mx-auto text-lg md:text-xl text-[#4A5B7C] leading-relaxed text-center px-6">
//           Modernize your practice with tools purpose-built for legal workflows —
//           enhancing accuracy, efficiency, and confidence at every stage.
//         </p>

//         <div className="mt-24 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 px-6">
//           {[
//             {
//               title: "Designed for Lawyers",
//               desc: "Every feature mirrors real courtroom and office workflows.",
//             },
//             {
//               title: "Precision & Control",
//               desc: "Structured systems that prioritize compliance and clarity.",
//             },
//             {
//               title: "Scalable by Nature",
//               desc: "Equally powerful for solo practitioners and legal teams.",
//             },
//           ].map((item, i) => (
//             <motion.div
//               key={i}
//               whileHover={{ y: -8 }}
//               transition={{ type: "spring", stiffness: 160 }}
//               className="
//                 rounded-[28px]
//                 bg-white/85
//                 backdrop-blur-xl
//                 border border-[#E2E8F4]
//                 p-9
//                 shadow-[0_30px_90px_rgba(30,40,90,0.14)]
//               "
//             >
//               <h3 className="text-xl font-semibold text-[#1E2A44]">
//                 {item.title}
//               </h3>
//               <p className="mt-3 text-[#55658A] leading-relaxed">
//                 {item.desc}
//               </p>
//             </motion.div>
//           ))}
//         </div>
//       </section>

//       {/* ================= FEATURES (FIXED — NO GAP) ================= */}
//       <Features />

//       {/* ================= MOBILE FEATURES ================= */}
//       <section>
//         <MobileFeatures />
//       </section>

//       {/* ================= TESTIMONIALS ================= */}
//       <section >
//         <Testimonials />
//       </section>

//       {/* ================= GET APP ================= */}
//       <section>
//         <GetApp />
//       </section>
//     </main>
//   );
// };

// export default Home;



















// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";

// import Features from "./Features";
// import GetApp from "./GetApp";
// import HeroSection from "./HeroSection";
// import Testimonials from "./Testimonials";
// import MobileFeatures from "./MobileFeatures";

// const smoothSpring = {
//   stiffness: 40,
//   damping: 30,
//   mass: 1.2,
// };

// const Home = () => {
//   const toolsRef = useRef(null);

//   const { scrollYProgress: toolsProgress } = useScroll({
//     target: toolsRef,
//     offset: ["start end", "end start"],
//   });

//   const toolsHeadingY = useSpring(
//     useTransform(toolsProgress, [0.25, 0.55], [60, -60]),
//     smoothSpring
//   );

//   return (
//     <main className="bg-white text-[#141414] overflow-hidden">
//       {/* ================= HERO ================= */}
//       <HeroSection />

//       {/* ================= TOOLS BUILT FOR LEGAL EXCELLENCE ================= */}
//       <section
//         ref={toolsRef}
//         className="
//           relative py-24 md:py-44 overflow-hidden
//          bg-[radial-gradient(ellipse_at_top,#EEF2FF_0%,#F3F6FF_45%,#FFFFFF_100%)]
//         "
//       >
//         {/* Mobile-optimized background glows */}
//         <div className="absolute -top-20 md:-top-32 left-1/4 w-[260px] md:w-[520px] h-[260px] md:h-[520px] bg-indigo-400/10 rounded-full blur-[100px] md:blur-[160px]" />
//         <div className="absolute top-32 md:top-40 right-1/4 w-[220px] md:w-[420px] h-[220px] md:h-[420px] bg-blue-300/10 rounded-full blur-[90px] md:blur-[140px]" />

//         {/* Heading animation container */}
//         <div className="relative overflow-hidden h-[110px] md:h-[180px]">
//           <div className="absolute inset-0 flex justify-center items-center">
//             <h2 className="text-2xl md:text-6xl font-semibold tracking-tight text-[#CBD3E3] text-center px-4">
//               Tools Built for Legal Excellence
//             </h2>
//           </div>

//           <motion.div
//             style={{ y: toolsHeadingY }}
//             className="absolute inset-0 flex justify-center items-center"
//           >
//             <h2 className="text-2xl md:text-6xl font-semibold tracking-tight text-[#1E2A44] text-center px-4">
//               Tools Built for Legal Excellence
//             </h2>
//           </motion.div>
//         </div>

//         <p className="mt-8 md:mt-12 max-w-3xl mx-auto text-base md:text-xl text-[#4A5B7C] leading-relaxed text-center px-6">
//           Modernize your practice with tools purpose-built for legal workflows —
//           enhancing accuracy, efficiency, and confidence at every stage.
//         </p>

//         <div className="mt-14 md:mt-24 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10 px-6">
//           {[
//             {
//               title: "Designed for Lawyers",
//               desc: "Every feature mirrors real courtroom and office workflows.",
//             },
//             {
//               title: "Precision & Control",
//               desc: "Structured systems that prioritize compliance and clarity.",
//             },
//             {
//               title: "Scalable by Nature",
//               desc: "Equally powerful for solo practitioners and legal teams.",
//             },
//           ].map((item, i) => (
//             <motion.div
//               key={i}
//               whileHover={{ y: -8 }}
//               transition={{ type: "spring", stiffness: 160 }}
//               className="
//                 rounded-[24px] md:rounded-[28px]
//                 bg-white/85
//                 backdrop-blur-xl
//                 border border-[#E2E8F4]
//                 p-6 md:p-9
//                 shadow-[0_20px_60px_rgba(30,40,90,0.14)]
//               "
//             >
//               <h3 className="text-lg md:text-xl font-semibold text-[#1E2A44]">
//                 {item.title}
//               </h3>
//               <p className="mt-3 text-sm md:text-base text-[#55658A] leading-relaxed">
//                 {item.desc}
//               </p>
//             </motion.div>
//           ))}
//         </div>
//       </section>

     

//       {/* ================= MOBILE FEATURES ================= */}
//       <section>
//         <MobileFeatures />
//       </section>
//  {/* ================= FEATURES ================= */}
//       <Features />
      
//       {/* ================= TESTIMONIALS ================= */}
//       <section>
//         <Testimonials />
//       </section>

//       {/* ================= GET APP ================= */}
//       <section>
//         <GetApp />
//       </section>
//     </main>
//   );
// };

// export default Home;













// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";

// import Features from "./Features";
// import GetApp from "./GetApp";
// import HeroSection from "./HeroSection";
// import Testimonials from "./Testimonials";
// import MobileFeatures from "./MobileFeatures";

// const smoothSpring = {
//   stiffness: 40,
//   damping: 30,
//   mass: 1.2,
// };

// const Home = () => {
//   const toolsRef = useRef(null);

//   const { scrollYProgress: toolsProgress } = useScroll({
//     target: toolsRef,
//     offset: ["start end", "end start"],
//   });

//   const toolsHeadingY = useSpring(
//     useTransform(toolsProgress, [0.25, 0.55], [60, -60]),
//     smoothSpring
//   );

//   return (
//     <main className="bg-white text-[#141414] overflow-hidden">
      
//       {/* ================= HERO ================= */}
//       <HeroSection />

//       {/* ================= TOOLS BUILT FOR LEGAL EXCELLENCE ================= */}
//       <section
//         ref={toolsRef}
//         className="
//           relative py-24 md:py-44 overflow-hidden
//           bg-[radial-gradient(ellipse_at_top,#FFF7ED_0%,#F8FAFF_45%,#FFFFFF_100%)]
//         "
//       >
//         {/* Background glow effects */}
//         <div className="absolute -top-20 md:-top-32 left-1/4 w-[260px] md:w-[520px] h-[260px] md:h-[520px] bg-indigo-400/15 rounded-full blur-[100px] md:blur-[160px]" />
//         <div className="absolute top-32 md:top-40 right-1/4 w-[220px] md:w-[420px] h-[220px] md:h-[420px] bg-violet-300/15 rounded-full blur-[90px] md:blur-[140px]" />

//         {/* Heading animation container */}
//         <div className="relative overflow-hidden h-[110px] md:h-[180px]">
          
//           <div className="absolute inset-0 flex justify-center items-center">
//             <h2 className="text-2xl md:text-6xl font-semibold tracking-tight text-[#CBD3E3] text-center px-4">
//               Tools Built for Legal Excellence
//             </h2>
//           </div>

//           <motion.div
//             style={{ y: toolsHeadingY }}
//             className="absolute inset-0 flex justify-center items-center"
//           >
//             <h2 className="text-2xl md:text-6xl font-semibold tracking-tight text-[#1E2A44] text-center px-4">
//               Tools Built for Legal Excellence
//             </h2>
//           </motion.div>

//         </div>

//         <p className="mt-8 md:mt-12 max-w-3xl mx-auto text-base md:text-xl text-[#4A5B7C] leading-relaxed text-center px-6">
//           Modernize your practice with tools purpose-built for legal workflows
//           enhancing accuracy, efficiency, and confidence at every stage.
//         </p>

//         <div className="mt-14 md:mt-24 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10 px-6">
          
//           {[
//             {
//               title: "Designed for Lawyers",
//               desc: "Manage clients, track case progress, update hearing statuses, and maintain organized records all through one efficient platform built to simplify your legal workflow.",
//             },
//             {
//               title: "Designed for Clients",
//               desc: "Track your case status, hearing updates, expenses, and important reports in real time. Get hearing updates directly from your lawyer and stay informed throughout your legal journey",
//             },
//             {
//               title: "Designed for Law Students",
//               desc: "Register on the platform to discover internship opportunities, connect with practicing lawyers, and gain valuable practical experience in the legal field.",
//             },
//           ].map((item, i) => (
//             <motion.div
//               key={i}
//               whileHover={{ y: -8 }}
//               transition={{ type: "spring", stiffness: 160 }}
//               className="
//                 rounded-[24px] md:rounded-[28px]
//                 bg-white/85
//                 backdrop-blur-xl
//                 border border-[#E2E8F4]
//                 p-6 md:p-9
//                 shadow-[0_20px_60px_rgba(30,40,90,0.14)]
//               "
//             >
//               <h3 className="text-lg md:text-xl font-semibold text-[#1E2A44]">
//                 {item.title}
//               </h3>

//               <p className="mt-3 text-sm md:text-base text-[#55658A] leading-relaxed">
//                 {item.desc}
//               </p>
//             </motion.div>
//           ))}

//         </div>
//       </section>

//       {/* ================= MOBILE FEATURES ================= */}
//       <section>
//         <MobileFeatures />
//       </section>

//       {/* ================= FEATURES ================= */}
//       {/* <Features /> */}

//       {/* ================= TESTIMONIALS ================= */}
//       <section>
//         <Testimonials />
//       </section>

//       {/* ================= GET APP ================= */}
//       <section>
//         <GetApp />
//       </section>

//     </main>
//   );
// };

// export default Home;











////without clickable 
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";

// import Features from "./Features";
// import GetApp from "./GetApp";
// import HeroSection from "./HeroSection";
// import Testimonials from "./Testimonials";
// import MobileFeatures from "./MobileFeatures";

// const smoothSpring = {
//   stiffness: 40,
//   damping: 30,
//   mass: 1.2,
// };

// const Home = () => {
//   const toolsRef = useRef(null);

//   const { scrollYProgress: toolsProgress } = useScroll({
//     target: toolsRef,
//     offset: ["start end", "end start"],
//   });

//   const toolsHeadingY = useSpring(
//     useTransform(toolsProgress, [0.25, 0.55], [60, -60]),
//     smoothSpring
//   );

//   return (
//     <main className="bg-white text-[#141414] overflow-hidden">

//       {/* ================= HERO ================= */}
//       <HeroSection />

//       {/* ================= TOOLS BUILT FOR LEGAL EXCELLENCE ================= */}
//       <section
//         ref={toolsRef}
//         className="
//           relative py-20 md:py-32 overflow-hidden
//           bg-[radial-gradient(ellipse_at_top,#FFF7ED_0%,#F8FAFF_45%,#FFFFFF_100%)]
//         "
//       >

//         {/* Background glow effects */}
//         <div className="absolute -top-20 md:-top-32 left-1/4 w-[260px] md:w-[520px] h-[260px] md:h-[520px] bg-indigo-400/15 rounded-full blur-[100px] md:blur-[160px]" />
//         <div className="absolute top-32 md:top-40 right-1/4 w-[220px] md:w-[420px] h-[220px] md:h-[420px] bg-violet-300/15 rounded-full blur-[90px] md:blur-[140px]" />

//         {/* Heading animation container */}
//         <div className="relative overflow-hidden h-[110px] md:h-[180px]">

//           <div className="absolute inset-0 flex justify-center items-center">
//             <h2 className="text-2xl md:text-6xl font-semibold tracking-tight text-[#CBD3E3] text-center px-4">
//               Tools Built for Legal Excellence
//             </h2>
//           </div>

//           <motion.div
//             style={{ y: toolsHeadingY }}
//             className="absolute inset-0 flex justify-center items-center"
//           >
//             <h2 className="text-2xl md:text-6xl font-semibold tracking-tight text-[#1E2A44] text-center px-4">
//               Tools Built for Legal Excellence
//             </h2>
//           </motion.div>

//         </div>

//         <p className="mt-6 md:mt-10 max-w-3xl mx-auto text-base md:text-xl text-[#4A5B7C] leading-relaxed text-center px-6">
//           Modernize your practice with tools purpose-built for legal workflows
//           enhancing accuracy, efficiency, and confidence at every stage.
//         </p>

//         <div className="mt-10 md:mt-16 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10 px-6">

//           {[
//             {
//               title: "Designed for Lawyers",
//               desc: "Manage clients, track case progress, update hearing statuses, and maintain organized records all through one efficient platform built to simplify your legal workflow.",
//             },
//             {
//               title: "Designed for Clients",
//               desc: "Track your case status, hearing updates, expenses, and important reports in real time. Get hearing updates directly from your lawyer and stay informed throughout your legal journey",
//             },
//             {
//               title: "Designed for Law Students",
//               desc: "Register on the platform to discover internship opportunities, connect with practicing lawyers, and gain valuable practical experience in the legal field.",
//             },
//           ].map((item, i) => (
//             <motion.div
//               key={i}
//               whileHover={{ y: -8 }}
//               transition={{ type: "spring", stiffness: 160 }}
//               className="
//                 rounded-[24px] md:rounded-[28px]
//                 bg-white/85
//                 backdrop-blur-xl
//                 border border-[#E2E8F4]
//                 p-6 md:p-9
//                 shadow-[0_20px_60px_rgba(30,40,90,0.14)]
//               "
//             >
//               <h3 className="text-lg md:text-xl font-semibold text-[#1E2A44]">
//                 {item.title}
//               </h3>

//               <p className="mt-3 text-sm md:text-base text-[#55658A] leading-relaxed">
//                 {item.desc}
//               </p>
//             </motion.div>
//           ))}

//         </div>
//       </section>

//       {/* ================= MOBILE FEATURES ================= */}
//       <section>
//         <MobileFeatures />
//       </section>

//       {/* ================= FEATURES ================= */}
//       {/* <Features /> */}

//       {/* ================= TESTIMONIALS ================= */}
//       <section>
//         <Testimonials />
//       </section>

//       {/* ================= GET APP ================= */}
//       <section>
//         <GetApp />
//       </section>

//     </main>
//   );
// };

// export default Home;





















// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { useNavigate } from "react-router-dom";

// import Features from "./Features";
// import GetApp from "./GetApp";
// import HeroSection from "./HeroSection";
// import Testimonials from "./Testimonials";
// import MobileFeatures from "./MobileFeatures";

// const smoothSpring = {
//   stiffness: 40,
//   damping: 30,
//   mass: 1.2,
// };

// const Home = () => {
//   const toolsRef = useRef(null);
//   const navigate = useNavigate();

//   const { scrollYProgress: toolsProgress } = useScroll({
//     target: toolsRef,
//     offset: ["start end", "end start"],
//   });

//   const toolsHeadingY = useSpring(
//     useTransform(toolsProgress, [0.25, 0.55], [60, -60]),
//     smoothSpring
//   );

//   return (
//     <main className="bg-white text-[#141414] overflow-hidden">

//       {/* ================= HERO ================= */}
//       <HeroSection />

//       {/* ================= TOOLS BUILT FOR LEGAL EXCELLENCE ================= */}
//       <section
//         ref={toolsRef}
//         className="
//           relative py-20 md:py-32 overflow-hidden
//           bg-[radial-gradient(ellipse_at_top,#FFF7ED_0%,#F8FAFF_45%,#FFFFFF_100%)]
//         "
//       >

//         {/* Background glow */}
//         <div className="absolute -top-20 md:-top-32 left-1/4 w-[260px] md:w-[520px] h-[260px] md:h-[520px] bg-indigo-400/15 rounded-full blur-[100px] md:blur-[160px]" />
//         <div className="absolute top-32 md:top-40 right-1/4 w-[220px] md:w-[420px] h-[220px] md:h-[420px] bg-violet-300/15 rounded-full blur-[90px] md:blur-[140px]" />

//         {/* Heading animation */}
//         <div className="relative overflow-hidden h-[110px] md:h-[180px]">

//           <div className="absolute inset-0 flex justify-center items-center">
//             <h2 className="text-2xl md:text-6xl font-semibold tracking-tight text-[#CBD3E3] text-center px-4">
//               Tools Built for Legal Excellence
//             </h2>
//           </div>

//           <motion.div
//             style={{ y: toolsHeadingY }}
//             className="absolute inset-0 flex justify-center items-center"
//           >
//             <h2 className="text-2xl md:text-6xl font-semibold tracking-tight text-[#1E2A44] text-center px-4">
//               Tools Built for Legal Excellence
//             </h2>
//           </motion.div>

//         </div>

//         {/* Subtitle */}
//         <p className="mt-6 md:mt-10 max-w-3xl mx-auto text-base md:text-xl text-[#4A5B7C] leading-relaxed text-center px-6">
//           Modernize your practice with tools purpose-built for legal workflows
//           enhancing accuracy, efficiency, and confidence at every stage.
//         </p>

//         {/* ================= CLICKABLE CARDS ================= */}
//         <div className="mt-10 md:mt-16 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10 px-6">

//           {[
//             {
//               title: "Designed for Lawyers",
//               desc: "Manage clients, track case progress, update hearing statuses, and maintain organized records all through one efficient platform built to simplify your legal workflow.",
//               path: "/Advocate",
//             },
//             {
//               title: "Designed for Clients",
//               desc: "Track your case status, hearing updates, expenses, and important reports in real time. Get hearing updates directly from your lawyer and stay informed throughout your legal journey.",
//               path: "/Enterprise",
//             },
//             {
//               title: "Designed for Law Students",
//               desc: "Register on the platform to discover internship opportunities, connect with practicing lawyers, and gain valuable practical experience in the legal field.",
//               //path: "/student",
//             },
//           ].map((item, i) => (
//             <motion.div
//               key={i}
//               whileHover={{ y: -10 }}
//               transition={{ type: "spring", stiffness: 180 }}
//               onClick={() => navigate(item.path)}
//               className="
//                 cursor-pointer group
//                 rounded-[24px] md:rounded-[28px]
//                 bg-white/85
//                 backdrop-blur-xl
//                 border border-[#E2E8F4]
//                 p-6 md:p-9
//                 shadow-[0_20px_60px_rgba(30,40,90,0.14)]
//                 transition-all duration-300
//                 hover:border-[#cda454]/40
//                 hover:shadow-[0_30px_80px_rgba(30,40,90,0.25)]
//               "
//             >
//               {/* Title */}
//               <h3 className="text-lg md:text-xl font-semibold text-[#1E2A44]">
//                 {item.title}
//               </h3>

//               {/* Description */}
//               <p className="mt-3 text-sm md:text-base text-[#55658A] leading-relaxed">
//                 {item.desc}
//               </p>

//               {/* Hover CTA */}
//               {/* Hover CTA (hide for Law Students) */}
// {/* {item.title !== "Designed for Law Students" && (
//   <div className="mt-4 text-[#cda454] text-sm opacity-0 group-hover:opacity-100 transition">
//     Explore →
//   </div>
// )} */}
// <div className="mt-4 text-center">

//   {/* ONLY for Lawyers */}
//   {item.title === "Designed for Lawyers" && (
//     <div className="text-[#55658A] italic text-sm mb-1 tracking-wide">
//       Customization as per your needs
//     </div>
//   )}

//   {/* For Lawyers + Clients (not for Students) */}
//   {item.title !== "Designed for Law Students" && (
//     <div className="text-[#cda454] text-sm inline-block cursor-pointer transition-all duration-300 hover:tracking-wider hover:translate-x-1">
//       Explore →
//     </div>
//   )}

// </div>
//             </motion.div>
//           ))}

//         </div>
//       </section>

//       {/* ================= MOBILE FEATURES ================= */}
//       <section>
//         <MobileFeatures />
//       </section>

//       {/* ================= TESTIMONIALS ================= */}
//       <section>
//         <Testimonials />
//       </section>

//       {/* ================= GET APP ================= */}
//       <section>
//         <GetApp />
//       </section>

//     </main>
//   );
// };

// export default Home;

























import { motion, useScroll, useTransform, useSpring } from "framer-motion";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";

import Features from "./Features";
import GetApp from "./GetApp";
import HeroSection from "./HeroSection";
import Testimonials from "./Testimonials";
import MobileFeatures from "./MobileFeatures";

const smoothSpring = {
  stiffness: 40,
  damping: 30,
  mass: 1.2,
};

const Home = () => {
  const toolsRef = useRef(null);
  const navigate = useNavigate();

  const { scrollYProgress: toolsProgress } = useScroll({
    target: toolsRef,
    offset: ["start end", "end start"],
  });

  const toolsHeadingY = useSpring(
    useTransform(toolsProgress, [0.25, 0.55], [60, -60]),
    smoothSpring
  );

  return (
    <main className="bg-white text-[#141414] overflow-hidden">

      {/* ================= HERO ================= */}
      <HeroSection />

      {/* ================= TOOLS BUILT FOR LEGAL EXCELLENCE ================= */}
      <section
        ref={toolsRef}
        className="
          relative py-20 md:py-32 overflow-hidden
          bg-[radial-gradient(ellipse_at_top,#FFF7ED_0%,#F8FAFF_45%,#FFFFFF_100%)]
        "
      >

        {/* Background glow */}
        <div className="absolute -top-20 md:-top-32 left-1/4 w-[260px] md:w-[520px] h-[260px] md:h-[520px] bg-indigo-400/15 rounded-full blur-[100px] md:blur-[160px]" />
        <div className="absolute top-32 md:top-40 right-1/4 w-[220px] md:w-[420px] h-[220px] md:h-[420px] bg-violet-300/15 rounded-full blur-[90px] md:blur-[140px]" />

        {/* Heading animation */}
        <div className="relative overflow-hidden h-[110px] md:h-[180px]">

          <div className="absolute inset-0 flex justify-center items-center">
            <h2 className="text-2xl md:text-6xl font-semibold tracking-tight text-[#CBD3E3] text-center px-4">
              Tools Built for Legal Excellence
            </h2>
          </div>

          <motion.div
            style={{ y: toolsHeadingY }}
            className="absolute inset-0 flex justify-center items-center"
          >
            <h2 className="text-2xl md:text-6xl font-semibold tracking-tight text-[#1E2A44] text-center px-4">
              Tools Built for Legal Excellence
            </h2>
          </motion.div>

        </div>

        {/* Subtitle */}
        <p className="mt-6 md:mt-10 max-w-3xl mx-auto text-base md:text-xl text-[#4A5B7C] leading-relaxed text-center px-6">
          Modernize your practice with tools purpose-built for legal workflows
          enhancing accuracy, efficiency, and confidence at every stage.
        </p>

        {/* ================= CLICKABLE CARDS ================= */}
        <div className="mt-10 md:mt-16 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10 px-6">

          {[
            {
              title: "Designed for Lawyers",
              desc: "Manage clients, track case progress, update hearing statuses, and maintain organized records all through one efficient platform built to simplify your legal workflow.",
              path: "/Advocate",
            },
            {
              title: "Designed for Clients",
              desc: "Track your case status, hearing updates, expenses, and reports in real time. Get hearing updates directly from your lawyer and stay informed throughout your legal journey.",
              path: "/Enterprise",
            },
            {
              title: "Designed for Law Students",
              desc: "Register on the platform to discover internship opportunities, connect with practicing lawyers, and gain valuable practical experience in the legal field.",
              //path: "/student",
            },
          ].map((item, i) => (
            <motion.div
              key={i}
              whileHover={{ y: -10 }}
              transition={{ type: "spring", stiffness: 180 }}
              onClick={() => navigate(item.path)}
              className="
                cursor-pointer group
                rounded-[24px] md:rounded-[28px]
                bg-white/85
                backdrop-blur-xl
                border border-[#E2E8F4]
                p-6 md:p-9
                shadow-[0_20px_60px_rgba(30,40,90,0.14)]
                transition-all duration-300
                hover:border-[#cda454]/40
                hover:shadow-[0_30px_80px_rgba(30,40,90,0.25)]
              "
            >
              {/* Title */}
              <h3 className="text-lg md:text-xl font-semibold text-[#1E2A44]">
                {item.title}
              </h3>

              {/* Description */}
              <p className="mt-3 text-sm md:text-base text-[#55658A] leading-relaxed">
                {item.desc}
              </p>

              {/* Hover CTA */}
              {/* Hover CTA (hide for Law Students) */}
{/* {item.title !== "Designed for Law Students" && (
  <div className="mt-4 text-[#cda454] text-sm opacity-0 group-hover:opacity-100 transition">
    Explore →
  </div>
)} */}
<div className="mt-4 text-center">

  {/* ONLY for Lawyers */}
  {item.title !== "Designed for Law Students" && (
    <div className="text-[#55658A] italic text-sm mb-1 tracking-wide">
      Customization as per your needs
    </div>
  )}

  {/* For Lawyers + Clients (not for Students) */}
  {item.title !== "Designed for Law Students" && (
    <div className="text-[#cda454] text-sm inline-block cursor-pointer transition-all duration-300 hover:tracking-wider hover:translate-x-1">
      Explore →
    </div>
  )}

</div>
            </motion.div>
          ))}

        </div>
      </section>

      {/* ================= MOBILE FEATURES ================= */}
      <section>
        <MobileFeatures />
      </section>

      {/* ================= TESTIMONIALS ================= */}
      <section>
        <Testimonials />
      </section>

      {/* ================= GET APP ================= */}
      <section>
        <GetApp />
      </section>

    </main>
  );
};

export default Home;
